import { render } from "./SettingsScreen.vue?vue&type=template&id=3ab82e25&scoped=true"
import script from "./SettingsScreen.vue?vue&type=script&lang=js"
export * from "./SettingsScreen.vue?vue&type=script&lang=js"

import "./SettingsScreen.vue?vue&type=style&index=0&id=3ab82e25&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab82e25"]])

export default __exports__